import Subject from './subject';

class PubSub {
  private subscribers: {
    [type: string]: Subject[];
  };

  constructor() {
    /**
     * {
     *  <type>: [subjects]
     * }
     */
    this.subscribers = {};
  }

  /**
   * event to publish
   * @param type  type of event
   * @param payload any object
   */
  publish(type: string, payload: any) {
    this.subscribers[type]?.forEach((subject) => {
      subject.callback(payload);
    });
  }

  unsubscribe(type: string, id: string, contextName: string) {
    const subs = this.subscribers[type] || [];
    let index = 0;
    let mIndex = -1;
    subs.forEach((subject) => {
      if (subject.id === id && subject.contextName === contextName) {
        mIndex = index;
      }
      index += 1;
    });

    /* add mIndex should not be -1 */
    if (mIndex !== -1) {
      subs.splice(mIndex, 1);
    }
  }

  unsubscribeAllWithEventType(type: string) {
    this.subscribers[type] = [];
  }

  subscribe(type: string, id: string | undefined, callback: Function, contextName: string, subscribeOnce: boolean) {
    this.subscribers[type] = this.subscribers[type] || [];
    let isSameSubjectExist = false;
    if (subscribeOnce) {
      this.subscribers[type].forEach((existingSubject) => {
        isSameSubjectExist = existingSubject.id === id && existingSubject.contextName === contextName;
      });
    }
    if (!isSameSubjectExist) {
      const subject = new Subject(type, id, callback, contextName);
      this.subscribers[type].push(subject);
    }
  }

  clearContext(contextName: string) {
    const subs = this.subscribers;
    Object.keys(subs).forEach((type) => {
      const subsByType = this.subscribers[type];
      const subjects: any[] = [];
      subsByType.forEach((subject) => {
        if (subject.contextName !== contextName) {
          subjects.push(subject);
        }
      });
      this.subscribers[type] = subjects;
    });
  }
}

export default new PubSub();
